export const generateTitleId = (title) => (
  title.replace(/[^\w\s]/gi, "").split(" ").map((part) => (
    part.toLowerCase()
  )).join("-")
);


// WEBPACK FOOTER //
// ./assets/pois/utils/generateTitleId.js